export enum EdlItemPacketStatusQuery {
    ACTIVE = -1
}